import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AliasPipe } from 'src/app/shared/pipes/alias.pipe';
import { HumanizePipe } from 'src/app/shared/pipes/human.pipe';
import { KeyPipe } from 'src/app/shared/pipes/key.pipe';
import { MonetaryPipe } from 'src/app/shared/pipes/monetary.pipe';
import { TitlePipe } from 'src/app/shared/pipes/title.pipe';

@NgModule({
  declarations: [
    AliasPipe,
    HumanizePipe,
    KeyPipe,
    MonetaryPipe,
    TitlePipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    AliasPipe,
    HumanizePipe,
    KeyPipe,
    MonetaryPipe,
    TitlePipe,
  ],
})
export class SharedPipesModule { }
